import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const Clock = React.forwardRef<Svg, { fillColor?: string } & SvgProps>(
  ({ fillColor = '#212121', ...props }, ref) => {
    return (
      <Svg
        ref={ref}
        width={24}
        height={24}
        fill='none'
        viewBox='0 0 24 24'
        {...props}
      >
        <Path
          d='M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10S2 17.522 2 12 6.477 2 12 2zm0 1.667c-4.595 0-8.333 3.738-8.333 8.333 0 4.595 3.738 8.333 8.333 8.333 4.595 0 8.333-3.738 8.333-8.333 0-4.595-3.738-8.333-8.333-8.333zM11.25 6a.75.75 0 01.743.648L12 6.75V12h3.25a.75.75 0 01.102 1.493l-.102.007h-4a.75.75 0 01-.743-.648l-.007-.102v-6a.75.75 0 01.75-.75z'
          fill={fillColor}
        />
      </Svg>
    )
  }
)

export default Clock
